import { get } from "lodash";
import serverCall from "../serverCall";

const login = async (userSignInRequest) => {
  const { email, password, code } = userSignInRequest;
  // Let errors propagate to the caller (the thunk) so failures show a real message
  // instead of crashing on an undefined response.
  const response = await serverCall.post(`/auth/login`, { email, password, code });

  const user = get(response, "data.apiresponse.data", null);
  if (!user) {
    throw new Error("Unexpected response from server.");
  }

  // Persist a session only once 2FA has fully passed (a token is present).
  // Otherwise the server is asking us to set up or enter a 2FA code (mfaStatus).
  if (user.mfaStatus === "OK" && user.token) {
    const userAndToken = { user: user.email, token: user.token, email };
    localStorage.setItem("twinbox-admin-store", JSON.stringify(userAndToken));
  }
  return user; // carries mfaStatus / totpSecret / otpauthUri for the UI handshake
};

const logout = () => {
  localStorage.removeItem("twinbox-admin-store");
  localStorage.removeItem("isLoggedIn");
};

const AuthenticationService = {
  login,
  logout,
};

export default AuthenticationService;
